import * as React from 'react'
import { StepperContextType, useStepperContext } from '../Stepper'
import clsx from 'clsx'
import { SxProps, sx as sxFunc } from '../sx'
import style from './index.module.scss'
import { StepContextType, useStepContext } from '../Step/StepContext'
import { capitalize } from '../../utils'

export interface StepConnectorClasses {
  /** Styles applied to the root element. */
  root: string
  /** Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: string
  /** Styles applied to the root element if `orientation="vertical"`. */
  vertical: string
  /** Styles applied to the root element if `alternativeLabel={true}`. */
  alternativeLabel: string
  /** State class applied to the root element if `active={true}`. */
  active: string
  /** State class applied to the root element if `completed={true}`. */
  completed: string
  /** State class applied to the root element if `disabled={true}`. */
  disabled: string
  /** Styles applied to the line element. */
  line: string
  /** Styles applied to the root element if `orientation="horizontal"`. */
  lineHorizontal: string
  /** Styles applied to the root element if `orientation="vertical"`. */
  lineVertical: string
}

export interface StepConnectorProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Override or extend the styles applied to the component.
   */
  classes?: Partial<StepConnectorClasses>
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx?: SxProps
}

export const StepConnector = React.forwardRef<
  HTMLDivElement,
  StepConnectorProps
>((props, ref) => {
  const { className, classes, sx, ...other } = props

  const { alternativeLabel, orientation = 'horizontal' } =
    useStepperContext() as StepperContextType

  const { active, disabled, completed } = useStepContext() as StepContextType

  return (
    <div
      ref={ref}
      className={clsx(
        style.root,
        classes?.root,
        style?.[`orientation-${orientation}`],
        classes?.[orientation],
        alternativeLabel && [style.alternativeLabel, classes?.alternativeLabel],
        active && [classes?.active],
        completed && [classes?.completed],
        disabled && [classes?.disabled],
        className,
        sxFunc(sx)
      )}
      {...other}
    >
      <span
        className={clsx(
          style.line,
          classes?.line,
          style?.[`orientation-${orientation}`],
          // @ts-ignore
          classes?.[`line${capitalize(orientation)}`]
        )}
      />
    </div>
  )
})

StepConnector.displayName = 'StepConnector'
